exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_wks-ext.js
// module id = 215
// module chunks = 1